export const painPoints = [
  {
    emoji: '🧭',
    title: 'Vous ne savez pas par où commencer',
    desc: 'La page blanche est votre ennemie. Cette méthode organise tout : conclusions, preuves et récits.',
  },
  {
    emoji: '🔤',
    title: "Vous luttez avec la précision de l'IA",
    desc: 'Arrêtez de deviner. Utilisez des structures validées par des avocats qui sonnent de manière clinique et professionnelle, pas robotique.',
  },
  {
    emoji: '🧩',
    title: 'Vous craignez le « Red Flag » de l’IA',
    desc: "L'IA générique sonne faux. Notre système garantit que vos documents semblent avoir été écrits par un vétéran avec 30 ans d'expérience.",
  },
  {
    emoji: '🎯',
    title: 'Vous voulez reprendre le contrôle de votre vie',
    desc: "Passer 4 heures sur un seul mémoire après une longue journée au tribunal n'est pas viable.",
  },
];
